import { Component, Input } from '@angular/core';
import { ClickableBoxItem } from 'app/components/common/clickableBox/clickableBox.component';

@Component({
    selector: 'psm-clickable-box-list',
    templateUrl: 'clickableBoxList.component.html',
    styleUrls: ['clickableBoxList.component.scss']
})
export class ClickableBoxListComponent {
    @Input()
    public items: ClickableBoxItem[];

    @Input()
    public isLoading: boolean;

}



// WEBPACK FOOTER //
// ./src/app/components/common/clickableBox/clickableBoxList.component.ts